module.exports = __webpack_public_path__ + "static/media/Price-listIcon.0205ddb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/Price-listIcon.png
// module id = 1821
// module chunks = 0